



























































































































































































































































































import {
  defineComponent, reactive, ref, Ref, onMounted, watch, computed,
} from '@vue/composition-api';
import { useRouter, useFormat } from '@ideavivat/vivat-2';

import {
  updatePurchaseOrder,
  getPurchaseOrder,
  getSuppliers,
  revisePurchaseOrder,
  getMaterials,
} from '@/api/index';

import purchaseOrderItemWithAmountTableOption from '@/table/PurchaseOrder/edit-purchase-order-item-with-amount';
import purchaseOrderMiscItemWithAmountTableOption from '@/table/PurchaseOrder/edit-purchase-order-misc-item-with-amount';

import CommonModalWithPreset from '@/components/CommonModalWithPreset.vue';
import StickyFooterActionBar from '@/components/StickyFooterActionBar.vue';
import useDownloadReport from '@/use/useDownloadReport';

const NOW = useFormat.date().computerShortDate();
const TOMORROW = useFormat.date(useFormat.date().dayjs.add(1, 'day')).computerShortDate();

const PanelWithPurchaseOrderRevise = defineComponent({
  components: {
    CommonModalWithPreset,
    StickyFooterActionBar,
  },
  props: {
    edit: { default: false },
    title: { default: '' },
  },
  setup(props) {
    const { route, router } = useRouter();
    const { getPreview } = useDownloadReport();
    const toDate = (date: string): string => useFormat.date(date).displayFullThaiDate();
    const refetchQuery = ref(false);
    const confirmModal = ref(null);

    const purchaseOrder = ref({
      id: -1,
      type: 'MATERIALS',
      subType: 'DEFAULT',
      code: '',
      created_at: NOW,
      invoice: '',
      items: [],
      misc_items: [],
      miscItems: [],
      ordered_at: NOW,
      remarks: null,
      credit_days: 90,
      supplier_id: -1,
      supplierRemarks: '',
      supplier: {
        id: -1,
        name: '',
        code: '',
        address: {
          address: '',
          district: { id: -1 },
          sub_district: { id: -1 },
          province: { id: -1 },
          zipcode: { id: -1 },
        },
      },
      total_price: 0,
      updated_at: NOW,
      vat: 0,
      vat_type: 'EX',
      discount: 0,
      target_date: '',
      customer_po: '',
      job_no: '',
      job_name: '',
      quotation_no: '',
      command: '',
      command_quantity: 0,
      command_unit: '',
      command_unit_price: 0,
    });

    const purchaseRequestTableData = ref({ total: 0, data: [] });
    const forceRender = ref(false);
    const form = reactive({
      id: -1,
      supplierId: -1,
      supplier: null,
      type: '',
      status: 'PENDING',
      remarks: '',
      supplierRemarks: '',
      targetDate: TOMORROW,
      items: [],
      miscItems: [],
      vatType: 'EX',
      discount: 0,
      customer_po: '',
      job_no: '',
      job_name: '',
      quotation_no: '',
      command: '',
      command_quantity: 0,
      command_unit: '',
      command_unit_price: 0,
      call: async () => {
        await revisePurchaseOrder(purchaseOrder.value.id, computedPurchaseOrderInput.value as any);
        (confirmModal.value as any).compose({ action: 'บันทึก', entity: 'ใบสั่งซื้อ' });
      },
      state: {
        value: 'READY',
      },
    });

    const computedPurchaseOrderInput = computed(() => ({
      supplierId: (form.supplier as any)?.id,
      type: purchaseOrder.value.type,
      status: form.status,
      remarks: form.remarks,
      purchaseRequestId: route.value.params.prId,
      creditDays: (form.supplier as any).credit_days || 0,
      supplierRemarks: form.supplierRemarks,
      miscItems: form.miscItems.map((item: any) => ({
        purchaseRequestMiscItemId: item.id,
        description: item.description,
        amount: item?.amount || 0,
        unit: item.unit,
        targetDate: form.targetDate || item.targetDate,
        pricePerUnit: item.pricePerUnit,
      })).filter((item: any) => item.amount > 0).filter((item: any) => item),
      items: form.items.map((item: any) => ({
        purchase_request_id: item.purchase_request_id || undefined,
        purchaseRequestItemId: item.purchase_request_item_id,
        materialId: item.material.id,
        bomItemId: item.bom_item_id,
        amount: item?.amount || 0,
        unit: item.unit,
        targetDate: form.targetDate || TOMORROW,
        pricePerUnit: item.pricePerUnit,
        purchaseUnit: item.purchaseUnit,
        amountPerUnit: parseFloat(item.amountPerUnit),
      })).filter((item: any) => item.amount > 0).filter((item: any) => item),

      vat: computedPurchaseOrderPrice.value.totalVat,
      vatType: form.vatType,
      subType: purchaseOrder.value.subType,
      discount: form.discount,
      customer_po: form.customer_po,
      job_no: form.job_no,
      job_name: form.job_name,
      quotation_no: form.quotation_no,

      command: form.command,
      command_quantity: form.command_quantity,
      command_unit: form.command_unit,
      command_unit_price: form.command_unit_price,
    }));

    async function getPurchaseOrderData() {
      purchaseOrder.value = (await getPurchaseOrder(route.value.params.poId)).data;
      form.supplier = purchaseOrder.value.supplier as any;
      form.supplierId = purchaseOrder.value.supplier_id;
      form.vatType = purchaseOrder.value.vat_type;
      form.targetDate = purchaseOrder.value.target_date;
      form.discount = purchaseOrder.value.discount;
      form.items = purchaseOrder.value.items.map((item: any) => ({
        ...item,
        pricePerUnit: item.price_per_unit || 0,
        targetDate: item.target_date,
        filledAmount: item.filled_amount,
        purchaseUnit: item.purchase_unit,
        amountPerUnit: item.amount_per_unit,
        neededAmount: item.amount,
      })) as never[];
      form.miscItems = purchaseOrder.value.misc_items.map((item: any) => ({
        ...item,
        pricePerUnit: item.price_per_unit || 0,
        targetDate: item.target_date,
        filledAmount: item.filled_amount,
        amountPerUnit: item.amount_per_unit,
        neededAmount: item.amount,
      })) as never[];

      form.customer_po = purchaseOrder.value.customer_po;
      form.job_no = purchaseOrder.value.job_no;
      form.job_name = purchaseOrder.value.job_name;
      form.quotation_no = purchaseOrder.value.quotation_no;

      form.command = purchaseOrder.value.command;
      form.command_quantity = purchaseOrder.value.command_quantity;
      form.command_unit = purchaseOrder.value.command_unit;
      form.command_unit_price = purchaseOrder.value.command_unit_price;
    }
    onMounted(async () => {
      await getPurchaseOrderData();
    });
    const computedTableInformation = computed(() => {
      if (purchaseOrder.value.type === 'MATERIALS') {
        return {
          data: form.items,
          amountTable: purchaseOrderItemWithAmountTableOption,
        };
      }
      return {
        data: form.miscItems,
        amountTable: purchaseOrderMiscItemWithAmountTableOption,
      };
    });
    const computedPurchaseOrderPrice = computed(() => {
      let price = 0;
      let key = 'miscItems';
      if (purchaseOrder.value.type === 'MATERIALS') key = 'items';
      (form as any)[key].forEach((item: any) => {
        price += parseFloat(item.pricePerUnit || 0) * parseFloat(item.amount || 0);
      });
      price += (form.command_unit_price * form.command_quantity) || 0;

      const vat = 7;
      let totalVat = 0;
      const priceAfterDiscount = price - form.discount > -1 ? price - form.discount : 0;
      let totalPrice = priceAfterDiscount;
      if (form.vatType === 'IN') {
        const beforeVat = ((priceAfterDiscount / (100 + vat)) * 100);
        totalVat = priceAfterDiscount - beforeVat;
      } else if (form.vatType === 'EX') {
        totalVat = (totalPrice * vat) / 100;
        totalPrice = priceAfterDiscount + totalVat;
      }

      return {
        totalPrice, totalVat, priceAfterDiscount, price,
      };
    });

    const computedSupplierAddress = computed(() => {
      if (!(purchaseOrder.value.supplier) || !(purchaseOrder.value.supplier as any).province_id) return '';
      if (!(purchaseOrder.value.supplier as any).district_id) return '';
      if (!(purchaseOrder.value.supplier as any).subdistrict_id) return '';
      const key = (purchaseOrder.value.supplier as any)?.show_as_english ? 'name_in_english' : 'name_in_thai';
      const subDistrict = (purchaseOrder.value.supplier as any).sub_district[key] !== 'NULL' ? (purchaseOrder.value.supplier as any).sub_district[key] : (purchaseOrder.value.supplier as any).sub_district.name_in_thai;
      return `${(purchaseOrder.value.supplier as any).address}${key === 'name_in_english' && (purchaseOrder.value.supplier as any).province_id !== 1 ? ' Tumbol ' : ' '}${subDistrict} ${(purchaseOrder.value.supplier as any).district[key]} ${(purchaseOrder.value.supplier as any).province[key]} ${(purchaseOrder.value.supplier as any).zipcode}`;
    });

    // Watch when route change;
    watch(() => route.value.params.poId, async (newVal, oldVal) => {
      if (newVal !== oldVal && newVal !== '') {
        await getPurchaseOrderData();
        refetchQuery.value = true;
      }
    });

    // use this to manually paginate create pr page;
    const page = ref(1);
    const PERPAGE = 200;
    const createPurchaseOrderPaginator = computed(() => ({
      perPage: PERPAGE,
      total: form[purchaseOrder.value.type === 'MATERIALS' ? 'items' : 'miscItems'].length,
      from: (page.value - 1) * PERPAGE,
      to: (page.value * PERPAGE),
      currentPage: 1,
      lastPage: form[purchaseOrder.value.type === 'MATERIALS' ? 'items' : 'miscItems'].length === 0 ? 1 : Math.ceil(form[purchaseOrder.value.type === 'MATERIALS' ? 'items' : 'miscItems'].length / PERPAGE),
      totalPages: form[purchaseOrder.value.type === 'MATERIALS' ? 'items' : 'miscItems'].length === 0 ? 1 : Math.ceil(form[purchaseOrder.value.type === 'MATERIALS' ? 'items' : 'miscItems'].length / PERPAGE),
    }));
    const displayData = computed(() => {
      if ((computedTableInformation.value.data as any).length < createPurchaseOrderPaginator.value.to) return (computedTableInformation.value.data as any).slice(createPurchaseOrderPaginator.value.from, (computedTableInformation.value.data as any).length);
      return (computedTableInformation.value.data as any).slice(createPurchaseOrderPaginator.value.from, createPurchaseOrderPaginator.value.to);
    });

    // Hook when CommonRichTableWithAxios finish fetching data;
    // use this to check total record & how many user has select item.
    function receivePurchaseRequestData(data: any) {
      purchaseRequestTableData.value = {
        data: data.data,
        total: data.total,
      };
    }

    function pendingToViewPreview() {
      getPreview('purchase_orders/preview', computedPurchaseOrderInput.value, 'Preview Purchase Order', ['miscItems', 'subType']);
    }

    // Condition to check form is valid
    const allowedToSubmit = computed(() => {
      if (!(purchaseOrder.value.supplier)) return false;
      // const pricePerUnitsArr = computedTableInformation.value.data.map((item: any) => parseInt(item.pricePerUnit, 10));
      // if (pricePerUnitsArr.indexOf(0) > -1) return false;
      // const amounts = computedTableInformation.value.data.map((item: any) => parseInt(item.amount, 10));
      // if (amounts.indexOf(0) > -1) return false;
      return true;
    });

    function getMaterialDisplay(mat: any) {
      let output = '';
      if ((mat.name && !(mat.code)) || (mat.code && !(mat.name))) output = `${mat.code || mat.name} ${output}`;
      else if (mat.code && mat.name) output = `${mat.code} - ${mat.name} ${output}`;
      if (mat.brand) output = `[${mat.brand}] ${output}`;
      return output;
    }

    return {
      NOW,
      toDate,
      computedPurchaseOrderInput,

      getSuppliers,
      getMaterials,
      getMaterialDisplay,

      forceRender,
      confirmModal,
      purchaseOrder,

      computedTableInformation,
      refetchQuery,

      form,
      allowedToSubmit,

      displayData,
      page,
      pagination: createPurchaseOrderPaginator,

      purchaseRequestTableData,
      receivePurchaseRequestData,

      computedPurchaseOrderPrice,
      computedSupplierAddress,

      pendingToViewPreview,
    };
  },
});

export default PanelWithPurchaseOrderRevise;
